'use client';

import React, { memo } from 'react';
import classNames from 'classnames';
import { ReactifyApi } from 'app/providers/mapProvider';
import { IMapMarker } from 'app/interfaces/map';

interface IMarkerProps extends IMapMarker {
  coordinates: [number, number];
  reactifyApi: ReactifyApi;
  isActive?: boolean;
  onMouseEnter?(id: number | string): void;
  onMouseLeave?(id: number | string): void;
}

const Marker = ({
  id,
  coordinates,
  reactifyApi,
  onMouseEnter,
  onMouseLeave,
  isActive = false
}: IMarkerProps) => {
  const { YMapMarker } = reactifyApi;

  if (coordinates?.length !== 2) return null;

  return (
    <YMapMarker coordinates={coordinates} zIndex={isActive ? 1 : 0}>
      <div
        className={classNames(
          'w-10 h-13 xl:w-15 xl:h-[67px]',
          '-translate-y-full -translate-x-[50%]',
          'transition-[transform,colors] duration-400 cursor-pointer',
          {
            'scale-105 z-1': isActive,
            'z-0': !isActive
          }
        )}
        onMouseEnter={() => onMouseEnter?.call(null, id)}
        onMouseLeave={() => onMouseLeave?.call(null, id)}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 60 67"
          fill="none"
          className="w-full h-full"
        >
          <path
            fillRule="evenodd"
            d="M15 0C6.716 0 0 6.716 0 15v30c0 8.284 6.716 15 15 15h8.255a3 3 0 0 1 2.667 1.626l1.441 2.799c1.102 2.139 4.149 2.175 5.301.062l1.595-2.924A3 3 0 0 1 36.892 60H45c8.284 0 15-6.716 15-15V15c0-8.284-6.716-15-15-15H15Z"
            clipRule="evenodd"
            className={classNames('transition-colors duration-400', {
              'fill-graphite-light': !isActive,
              'fill-brown': isActive
            })}
          />
          <path
            fill="#F8F5F3"
            fillRule="evenodd"
            d="m46.316 9.882.38-.424c.292-.32.592-.633.9-.94l.04-.041a.058.058 0 0 1 .096.008c.006.01.008.023.007.036L47.5 51.467a.057.057 0 0 1-.036.058.058.058 0 0 1-.066-.017l-.04-.04c-.302-.31-.597-.628-.887-.951l-.38-.432a30.629 30.629 0 0 1 .231-40.203m0 2.231a29.2 29.2 0 0 0-.204 35.742l.204-35.742ZM13.667 31.238a30.591 30.591 0 0 1 29.536 22.63v.057a.058.058 0 0 1-.089.064L6.038 32.301a.058.058 0 0 1 0-.11h.058c.419-.105.84-.203 1.266-.291l.564-.112a30.726 30.726 0 0 1 5.707-.533m0 1.416a29.176 29.176 0 0 1 27.07 18.29L9.855 32.915a29.348 29.348 0 0 1 3.78-.244ZM40.487 13.118A30.591 30.591 0 0 1 7.95 27.81l-.556-.118a27.828 27.828 0 0 1-1.267-.31H6.07a.058.058 0 0 1 0-.108L43.39 6.009a.058.058 0 0 1 .086.033.058.058 0 0 1-.001.035v.057a30.066 30.066 0 0 1-.564 1.786 30.74 30.74 0 0 1-2.393 5.208m-1.226-.71A29.175 29.175 0 0 1 9.916 26.717L40.97 9.024a29.36 29.36 0 0 1-1.68 3.395"
            clipRule="evenodd"
          />
        </svg>
      </div>
    </YMapMarker>
  );
};

export default memo(Marker);
